// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-badge-content {
  background: #5ea1d8;
}

.approval-hint {
  font-size: 13px;
  color: #6b7280;
  align-self: center;
}

@media (max-width: 767px) {
  .mobile-pricing-view .pricing-row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 6px;
  }
}
.main-div {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 89vh;
  background: #efeeee !important;
}
.main-div .main-content {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 20px 20px !important;
  width: 90%;
  max-width: 600px;
  max-height: auto;
  width: 100%;
  position: relative;
  padding: 0px;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  text-align: center;
}
.main-div .mat-form-field-appearance-legacy .mat-form-field-underline {
  background: lightgray !important;
}
.main-div .font16 {
  font-size: 14px !important;
  font-family: "Raleway";
}
.main-div .table-wrapper .table-inner {
  border-radius: 5px;
  max-height: 300px;
  height: 100%;
  position: relative;
  overflow: hidden;
  min-height: 300px;
  border: 1px solid lightgray;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-div .table-wrapper .table-inner img.img-display {
  max-width: 100%;
  max-height: 250px;
  object-fit: contain;
}
.main-div .table-wrapper .table-inner video.video-display {
  width: 100%;
  height: 150px !important;
}
.main-div .table-wrapper p {
  color: rgba(0, 0, 0, 0.54) !important;
  text-align: left !important;
  padding: 10px;
  line-height: 20px;
}
.main-div button.close {
  position: absolute;
  top: 20px;
  right: 22px;
  z-index: 10;
}
.main-div .btn-primary {
  background-color: #5ea1d8;
  border: none;
  margin-bottom: 10px;
}
.main-div .flowbycat {
  background-color: transparent;
}
.main-div .hide_file {
  position: absolute;
  z-index: 1000;
  opacity: 0;
  cursor: pointer;
  right: 0;
  top: 0;
  height: 100%;
  font-size: 24px;
  width: 100%;
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .main-div .main-div {
    min-height: 92vh;
  }
  .main-div .main-content {
    width: 75%;
  }
}

@media only screen and (max-width: 767px) and (min-width: 320px) {
  .main-div {
    background: #fff !important;
  }
  .main-div .main-content {
    width: calc(100% - 30px) !important;
    padding: 5px 5px 20px !important;
  }
}
@media (max-width: 460px) {
  .main-div .table-wrapper .table-inner {
    max-height: 150px;
    min-height: 150px;
  }
  .main-div .table-wrapper .table-inner img.img-display {
    max-height: 100px;
  }
  .main-div .table-wrapper .table-inner .video-display {
    max-height: 150px !important;
  }
}
.card {
  height: 100px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 30%;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.container {
  padding: 2px 16px;
}

/* new design starta here*/
.createBund .card {
  width: calc(50% - 30px);
  box-shadow: none;
  margin: 40px auto 0px auto;
  height: auto !important;
}
.createBund .card .container {
  padding: 5px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.createBund .card h4 {
  margin: 0px !important;
}
.createBund .card p {
  margin: 0px !important;
}
.createBund .card .mat-icon {
  width: auto;
  color: gray;
  text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
  font-size: 35px !important;
  height: 35px !important;
}
.createBund form + .row {
  text-align: center;
  width: 100%;
  margin: 0px !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.createBund form + .row > div {
  width: 31% !important;
  position: relative;
  margin: 0px 5px;
}
.createBund form + .row > div span {
  position: absolute;
  top: 0px;
  left: 0px;
  color: black;
  font-size: 24px !important;
  z-index: 10;
}
.createBund form + .row > div span.pricebadge {
  left: unset !important;
}
.createBund form + .row > div span.deletbadge {
  left: 10px !important;
}
.createBund form + .row > div .item {
  width: 100% !important;
}
.createBund .item {
  padding: 5px;
  width: 31% !important;
  margin-right: 0px !important;
  margin-left: 0px !important;
  border: 1px solid #ddd !important;
  margin: 5px !important;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: -2px 2px 7px hsla(0, 6%, 77%, 0.5);
}
.createBund .item .example-margin {
  position: absolute;
  top: 5px;
  right: 3px;
  color: gray;
}
.createBund .item p {
  text-align: left;
}
.createBund .item img {
  border: 1px solid #ddd;
  width: calc(100% - 10px) !important;
  height: 150px !important;
  border-radius: 0 !important;
  margin: 5px !important;
  object-fit: cover;
}
.createBund .item .with-icon {
  display: flex;
  align-items: center;
}
.createBund .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 20px !important;
}
.createBund .item .with-icon span {
  position: relative !important;
  left: 0px;
  display: flex;
  align-items: center;
}
.createBund .mat-checkbox {
  position: absolute;
  top: 5px;
  right: 5px;
}
.createBund .mat-checkbox .mat-checkbox-frame {
  border-color: rgb(94, 161, 216) !important;
}

@media (max-width: 768px) {
  .createBund .main-div .table-wrapper .table-inner {
    min-height: 210px !important;
  }
  .createBund form + .row {
    width: 100% !important;
    display: flex;
    justify-content: end !important;
  }
}
@media (max-width: 460px) {
  .createBund form + .row {
    width: 100% !important;
    display: flex;
    justify-content: space-between;
  }
  .createBund form + .row > div {
    width: 47% !important;
    position: relative;
    margin: 0px 5px;
  }
  .createBund .item {
    width: 47% !important;
    margin: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 1024px) {
  .createBund form + .row {
    width: 100% !important;
    display: flex;
    justify-content: space-evenly;
  }
  .createBund .item {
    width: 31% !important;
    margin: 5px !important;
  }
}
/*new design starts here*/
.newdesign-createbundle h4 {
  font-size: 17px !important;
  font-weight: 600 !important;
  margin: 10px 0px !important;
  line-height: 26px !important;
  text-align: left;
}
.newdesign-createbundle button.close {
  position: absolute;
  top: 10px;
  right: 20px;
}

.upload-tab-item {
  display: flex;
  padding: 0px;
  margin-top: 10px;
  flex-wrap: wrap;
  align-items: center;
}
.upload-tab-item .inputfield {
  order: 1;
}
.upload-tab-item .file-details {
  order: 4;
  display: block;
  width: 100%;
  text-align: left;
  padding: 0px 10px;
}
.upload-tab-item .item-field {
  order: 2;
  height: 56px;
}
.upload-tab-item .addbtn {
  order: 3;
  height: 56px;
}
.upload-tab-item .example-list {
  margin-bottom: 20px;
}
.upload-tab-item .example-list .example-box {
  border: 1px solid gray;
  display: flex;
  align-items: center;
}
.upload-tab-item .example-list .example-box span {
  flex: 2;
  display: block;
  height: 100%;
  text-align: left;
  padding: 0px 10px 0px 0px;
}
.upload-tab-item .example-list .example-box span:last-child {
  flex: 1;
  text-align: center;
}
.upload-tab-item .example-list .example-box span:nth-child(2) {
  border-left: 1px solid gray;
  border-right: 1px solid gray;
}
.upload-tab-item .example-list .example-box + .example-box {
  border-top: 0px;
}

.tab-design-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 10px;
}
.tab-design-wrapper .tab-design-item:last-child {
  display: block;
  position: relative;
  order: 4;
}
.tab-design-wrapper .addbtn {
  height: 56px;
}
.tab-design-wrapper .example-list {
  margin-bottom: 20px;
}
.tab-design-wrapper .example-list .example-box {
  border: 1px solid gray;
  display: flex;
  align-items: center;
}
.tab-design-wrapper .example-list .example-box span {
  border-right: 1px solid gray;
  display: flex;
  text-align: left;
  padding: 5px 10px 5px 5px;
  align-self: stretch;
  align-items: center;
  word-break: break-all;
}
.tab-design-wrapper .example-list .example-box span:first-child {
  width: 70%;
  word-break: break-all;
}
.tab-design-wrapper .example-list .example-box span:nth-child(2) {
  width: 70%;
}
.tab-design-wrapper .example-list .example-box span:nth-child(3) {
  width: 50px;
  justify-content: center;
}
.tab-design-wrapper .example-list .example-box span:last-child {
  width: 50px;
  text-align: center;
  border-right: 0px;
  justify-content: center;
}
.tab-design-wrapper .example-list .example-box + .example-box {
  border-top: 0px;
}

video.video-display[poster] {
  height: 150px !important;
  padding-bottom: 12%;
  max-width: 100% !important;
  width: 100% !important;
  text-align: center;
  cursor: pointer;
  min-height: 150px !important;
}

.img-div-left.small-spinner {
  position: absolute !important;
  width: 100px !important;
  height: 100px !important;
  top: 100px !important;
}
.img-div-left.small-spinner img {
  width: 100px !important;
  height: 100px !important;
  top: unset !important;
}

.label-button {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.label-button label {
  margin-bottom: 0px !important;
}

.quill-wrapper .fl-left {
  margin-bottom: 10px;
  display: block;
}
.quill-wrapper quill-editor {
  width: 100%;
}

.quill-wrapper .fl-left {
  margin-bottom: 10px;
  display: block;
}
.quill-wrapper quill-editor {
  width: 100%;
}

.fileExplorer {
  margin-top: 20px;
  margin-bottom: 0px !important;
}

.clickable-text {
  color: #007bff; /* Link color */
  cursor: pointer; /* Pointer cursor on hover */
  text-decoration: underline; /* Underline text */
}

.clickable-text:hover {
  color: #0056b3; /* Darker shade on hover */
}

.doc-icon-btn {
  cursor: pointer;
  padding: 5px;
  font-size: 20px;
  color: #6b7280;
  border-radius: 4px;
  transition: color 0.2s ease, background 0.2s ease;
}
.doc-icon-btn:hover {
  color: #111827;
  background: rgba(0, 0, 0, 0.06);
}

:host-context(body.theme-dark) .doc-icon-btn {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .doc-icon-btn:hover {
  color: #e2e8f0 !important;
  background: rgba(148, 163, 184, 0.12) !important;
}
:host-context(body.theme-dark) .example-box.document-row .document,
:host-context(body.theme-dark) .example-box.document-row .link {
  color: #cbd5e1 !important;
}

.bundle-access-type-row {
  margin-bottom: 12px;
}

.bundle-access-type-options {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}

.access-type-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #fff;
  color: #334155;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.access-type-btn mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}
.access-type-btn.selected {
  border-color: #5ea1d8;
  background: #eef6fc;
  color: #1e4d72;
}
.access-type-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.access-type-check {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-left: 2px;
}

::ng-deep .access-menu-current {
  margin-left: 8px;
  font-size: 11px;
  font-weight: 600;
  color: #1976d2;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/edit-bundle/edit-bundle.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EAEI;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,2BAAA;IACA,QAAA;EAAJ;AACF;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;AAFF;AAGE;EACE,kCAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;AADJ;AAIE;EACE,gCAAA;AAFJ;AAKE;EACE,0BAAA;EACA,sBAAA;AAHJ;AAMI;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJN;AAKM;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AAHR;AAKM;EACE,WAAA;EACA,wBAAA;AAHR;AAOI;EACE,qCAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;AALN;AAQE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AANJ;AASE;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;AAPJ;AASE;EACE,6BAAA;AAPJ;AASE;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAPJ;AAUE;EACE;IACE,gBAAA;EARJ;EAUE;IACE,UAAA;EARJ;AACF;;AAYA;EACE;IACE,2BAAA;EATF;EAUE;IACE,mCAAA;IACA,gCAAA;EARJ;AACF;AAWA;EAEI;IACE,iBAAA;IACA,iBAAA;EAVJ;EAWI;IACE,iBAAA;EATN;EAWI;IACE,4BAAA;EATN;AACF;AAcA;EACE,aAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;AAZF;;AAeA;EACE,2CAAA;AAZF;;AAeA;EACE,iBAAA;AAZF;;AAcA,0BAAA;AAEE;EACE,uBAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;AAZJ;AAaI;EACE,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAZN;AAeI;EACE,sBAAA;AAbN;AAeI;EACE,sBAAA;AAbN;AAeI;EACE,WAAA;EACA,WAAA;EACA,iDAAA;EACA,0BAAA;EACA,uBAAA;AAbN;AAgBE;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAdJ;AAeI;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;AAbN;AAcM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,0BAAA;EACA,WAAA;AAZR;AAaQ;EACE,sBAAA;AAXV;AAaQ;EACE,qBAAA;AAXV;AAcM;EACE,sBAAA;AAZR;AAgBE;EACE,YAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;EAEA,iCAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8CAAA;AAfJ;AAgBI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AAdN;AAgBI;EACE,gBAAA;AAdN;AAiBI;EACE,sBAAA;EACA,mCAAA;EACA,wBAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;AAfN;AAiBI;EACE,aAAA;EACA,mBAAA;AAfN;AAgBM;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;AAdR;AAgBM;EACE,6BAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAdR;AAmBE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAjBJ;AAkBI;EACE,0CAAA;AAhBN;;AAqBA;EAGM;IACE,4BAAA;EApBN;EAuBE;IACE,sBAAA;IACA,aAAA;IACA,+BAAA;EArBJ;AACF;AAyBA;EAEI;IACE,sBAAA;IACA,aAAA;IACA,8BAAA;EAxBJ;EAyBI;IACE,qBAAA;IACA,kBAAA;IACA,eAAA;EAvBN;EA0BE;IACE,qBAAA;IACA,sBAAA;EAxBJ;AACF;AA2BA;EAEI;IACE,sBAAA;IACA,aAAA;IACA,6BAAA;EA1BJ;EA4BE;IACE,qBAAA;IACA,sBAAA;EA1BJ;AACF;AA8BA,yBAAA;AAEE;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;AA7BJ;AA+BE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AA7BJ;;AAiCA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AA9BF;AA+BE;EACE,QAAA;AA7BJ;AA+BE;EACE,QAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AA7BJ;AA+BE;EACE,QAAA;EACA,YAAA;AA7BJ;AA+BE;EACE,QAAA;EACA,YAAA;AA7BJ;AA+BE;EAEE,mBAAA;AA9BJ;AA+BI;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;AA7BN;AA8BM;EACE,OAAA;EAEA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;AA7BR;AA8BQ;EACE,OAAA;EACA,kBAAA;AA5BV;AA8BQ;EACE,2BAAA;EACA,4BAAA;AA5BV;AA+BM;EACE,eAAA;AA7BR;;AAmCA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAhCF;AAmCI;EACE,cAAA;EACA,kBAAA;EACA,QAAA;AAjCN;AAoCE;EACE,YAAA;AAlCJ;AAoCE;EAEE,mBAAA;AAnCJ;AAoCI;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;AAlCN;AAmCM;EAEE,4BAAA;EACA,aAAA;EAEA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AAnCR;AAoCQ;EACE,UAAA;EACA,qBAAA;AAlCV;AAoCQ;EACE,UAAA;AAlCV;AAoCQ;EACE,WAAA;EACA,uBAAA;AAlCV;AAoCQ;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AAlCV;AAqCM;EACE,eAAA;AAnCR;;AAwCA;EACE,wBAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AArCF;;AAuCA;EAGE,6BAAA;EACA,uBAAA;EACA,wBAAA;EAEA,qBAAA;AAvCF;AAyCA;EACE,uBAAA;EACA,wBAAA;EACA,qBAAA;AAvCF;;AA0CA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAvCF;AAwCE;EACE,6BAAA;AAtCJ;;AA0CE;EACE,mBAAA;EACA,cAAA;AAvCJ;AAyCE;EACE,WAAA;AAvCJ;;AA2CE;EACE,mBAAA;EACA,cAAA;AAxCJ;AA0CE;EACE,WAAA;AAxCJ;;AA2CA;EACE,gBAAA;EACA,6BAAA;AAxCF;;AA2CA;EACE,cAAA,EAAA,eAAA;EACA,eAAA,EAAA,4BAAA;EACA,0BAAA,EAAA,mBAAA;AAxCF;;AA2CA;EACE,cAAA,EAAA,0BAAA;AAxCF;;AA2CA;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iDAAA;AAxCF;AA0CE;EACE,cAAA;EACA,+BAAA;AAxCJ;;AA6CE;EACE,yBAAA;AA1CJ;AA4CI;EACE,yBAAA;EACA,gDAAA;AA1CN;AA+CI;;EAEE,yBAAA;AA7CN;;AAkDA;EACE,mBAAA;AA/CF;;AAkDA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;AA/CF;;AAkDA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA/CF;AAiDE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA/CJ;AAkDE;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAhDJ;AAmDE;EACE,aAAA;EACA,mBAAA;AAjDJ;;AAqDA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAlDF;;AAqDA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAlDF","sourcesContent":[".mat-badge-content {\n  background: #5ea1d8;\n}\n\n.approval-hint {\n  font-size: 13px;\n  color: #6b7280;\n  align-self: center;\n}\n\n@media (max-width: 767px) {\n  .mobile-pricing-view {\n    .pricing-row {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      justify-content: flex-start;\n      gap: 6px;\n    }\n  }\n}\n\n.main-div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 89vh;\n  background: #efeeee !important;\n  .main-content {\n    border-radius: 10px 10px 10px 10px;\n    background: #fff;\n    padding: 20px 20px !important;\n    width: 90%;\n    max-width: 600px;\n    max-height: auto;\n    width: 100%;\n    position: relative;\n    padding: 0px;\n    border: 1px solid #ddd;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    text-align: center;\n    // border: 0.5px solid lightgrey;\n  }\n  .mat-form-field-appearance-legacy .mat-form-field-underline {\n    background: lightgray !important;\n  }\n\n  .font16 {\n    font-size: 14px !important;\n    font-family: \"Raleway\"; \n  }\n  .table-wrapper {\n    .table-inner {\n      border-radius: 5px;\n      max-height: 300px;\n      height: 100%;\n      position: relative;\n      overflow: hidden;\n      min-height: 300px;\n      border: 1px solid lightgray;\n      background: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      img.img-display {\n        max-width: 100%;\n        max-height: 250px;\n        object-fit: contain;\n      }\n      video.video-display {\n        width: 100%;\n        height: 150px !important;\n      }\n    }\n\n    p {\n      color: rgba(0, 0, 0, 0.54) !important;\n      text-align: left !important;\n      padding: 10px;\n      line-height: 20px;\n    }\n  }\n  button.close {\n    position: absolute;\n    top: 20px;\n    right: 22px;\n    z-index: 10;\n  }\n\n  .btn-primary {\n    background-color: #5ea1d8;\n    border: none;\n    margin-bottom: 10px;\n  }\n  .flowbycat {\n    background-color: transparent;\n  }\n  .hide_file {\n    position: absolute;\n    z-index: 1000;\n    opacity: 0;\n    cursor: pointer;\n    right: 0;\n    top: 0;\n    height: 100%;\n    font-size: 24px;\n    width: 100%;\n  }\n\n  @media only screen and (max-width: 1024px) and (min-width: 768px) {\n    .main-div {\n      min-height: 92vh;\n    }\n    .main-content {\n      width: 75%;\n    }\n  }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 320px) {\n  .main-div {\n    background: #fff !important;\n    .main-content {\n      width: calc(100% - 30px) !important;\n      padding: 5px 5px 20px !important;\n    }\n  }\n}\n@media (max-width: 460px) {\n  .main-div {\n    .table-wrapper .table-inner {\n      max-height: 150px;\n      min-height: 150px;\n      img.img-display {\n        max-height: 100px;\n      }\n      .video-display {\n        max-height: 150px !important;\n      }\n    }\n  }\n}\n\n.card {\n  height: 100px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n  width: 30%;\n}\n\n.card:hover {\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n}\n\n.container {\n  padding: 2px 16px;\n}\n/* new design starta here*/\n.createBund {\n  .card {\n    width: calc(50% - 30px);\n    box-shadow: none;\n    margin: 40px auto 0px auto;\n    height: auto !important;\n    .container {\n      padding: 5px 16px;\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n    }\n\n    h4 {\n      margin: 0px !important;\n    }\n    p {\n      margin: 0px !important;\n    }\n    .mat-icon {\n      width: auto;\n      color: gray;\n      text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n      font-size: 35px !important;\n      height: 35px !important;\n    }\n  }\n  form + .row {\n    text-align: center;\n    width: 100%;\n    margin: 0px !important;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    & > div {\n      width: 31% !important;\n      position: relative;\n      margin: 0px 5px;\n      span {\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        color: black;\n        font-size: 24px !important;\n        z-index: 10;\n        &.pricebadge{\n          left:unset !important;\n        }\n        &.deletbadge{\n          left:10px !important;\n        }\n      }\n      .item {\n        width: 100% !important;\n      }\n    }\n  }\n  .item {\n    padding: 5px;\n    width: 31% !important;\n    margin-right: 0px !important;\n    margin-left: 0px !important;\n    // width: calc(100% - 10px)!important;\n    border: 1px solid #ddd !important;\n    margin: 5px !important;\n    overflow: hidden;\n    background: #fff;\n    position: relative;\n    box-shadow: -2px 2px 7px hsl(0deg 6% 77% / 50%);\n    .example-margin {\n      position: absolute;\n      top: 5px;\n      right: 3px;\n      color: gray;\n    }\n    p {\n      text-align: left;\n    }\n\n    img {\n      border: 1px solid #ddd;\n      width: calc(100% - 10px) !important;\n      height: 150px !important;\n      border-radius: 0 !important;\n      margin: 5px !important;\n      object-fit: cover;\n    }\n    .with-icon {\n      display: flex;\n      align-items: center;\n      img {\n        width: 30px !important;\n        height: 30px !important;\n        border-radius: 20px !important;\n      }\n      span{\n        position: relative !important;\n        left:0px;  \n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n\n  .mat-checkbox {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    .mat-checkbox-frame {\n      border-color: rgb(94, 161, 216) !important;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .createBund {\n    .main-div {\n      .table-wrapper .table-inner {\n        min-height: 210px !important;\n      }\n    }\n    form + .row {\n      width: 100% !important;\n      display: flex;\n      justify-content: end !important;\n    }\n  }\n}\n\n@media (max-width: 460px) {\n  .createBund {\n    form + .row {\n      width: 100% !important;\n      display: flex;\n      justify-content: space-between;\n      & > div {\n        width: 47% !important;\n        position: relative;\n        margin: 0px 5px;\n      }\n    }\n    .item {\n      width: 47% !important;\n      margin: 5px !important;\n    }\n  }\n}\n@media only screen and (min-width: 461px) and (max-width: 1024px) {\n  .createBund {\n    form + .row {\n      width: 100% !important;\n      display: flex;\n      justify-content: space-evenly;\n    }\n    .item {\n      width: 31% !important;\n      margin: 5px !important;\n    }\n  }\n}\n\n/*new design starts here*/\n.newdesign-createbundle{\n  h4{\n    font-size: 17px !important;\n    font-weight: 600 !important;\n    margin: 10px 0px !important;\n    line-height: 26px !important;\n    text-align: left;\n  }\n  button.close{\n    position: absolute;\n    top: 10px;\n    right: 20px;\n}\n}\n\n.upload-tab-item {\n  display: flex;\n  padding: 0px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n  .inputfield {\n    order: 1;\n  }\n  .file-details {\n    order: 4;\n    display: block;\n    width: 100%;\n    text-align: left;\n    padding: 0px 10px;\n  }\n  .item-field {\n    order: 2;\n    height: 56px;\n  }\n  .addbtn {\n    order: 3;\n    height: 56px;\n  }\n  .example-list {\n    // border:1px solid gray;\n    margin-bottom: 20px;\n    .example-box {\n      border: 1px solid gray;\n      display: flex;\n      align-items: center;\n      span {\n        flex: 2;\n        // border-right: 1px solid gray;\n        display: block;\n        height: 100%;\n        text-align: left;\n        padding: 0px 10px 0px 0px;\n        &:last-child {\n          flex: 1;\n          text-align: center;\n        }\n        &:nth-child(2) {\n          border-left: 1px solid gray;\n          border-right: 1px solid gray;\n        }\n      }\n      & + .example-box {\n        border-top: 0px;\n      }\n    }\n  }\n}\n\n.tab-design-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-top: 10px;\n  // display: none !important;\n  .tab-design-item {\n    &:last-child {\n      display: block;\n      position: relative;\n      order: 4;\n    }\n  }\n  .addbtn {\n    height: 56px;\n  }\n  .example-list {\n    // border:1px solid gray;\n    margin-bottom: 20px;\n    .example-box {\n      border: 1px solid gray;\n      display: flex;\n      align-items: center;\n      span {\n        // flex: 2;\n        border-right: 1px solid gray;\n        display: flex;\n        // height: 100%;\n        text-align: left;\n        padding: 5px 10px 5px 5px;\n        align-self: stretch;\n        align-items: center;\n        word-break: break-all;\n        &:first-child {\n          width: 70%;\n          word-break: break-all;\n        }\n        &:nth-child(2) {\n          width: 70%;\n        }\n        &:nth-child(3) {\n          width: 50px;\n          justify-content: center;\n        }\n        &:last-child {\n          width: 50px;\n          text-align: center;\n          border-right: 0px;\n          justify-content: center;\n        }\n      }\n      & + .example-box {\n        border-top: 0px;\n      }\n    }\n  }\n}\nvideo.video-display[poster] {\n  height: 150px !important;\n  padding-bottom: 12%;\n  max-width: 100% !important;\n  width: 100% !important;\n  text-align: center;\n  cursor: pointer;\n  min-height: 150px !important;\n}\n.img-div-left.small-spinner{\n \n   \n  position: absolute !important;\n  width: 100px !important;\n  height: 100px !important;\n \n  top: 100px !important;\n\nimg{\n  width:100px !important;\n  height:100px !important;\n  top:unset !important;\n}\n}\n.label-button{\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  label{\n    margin-bottom: 0px !important;\n  }\n}\n.quill-wrapper{\n  .fl-left{\n    margin-bottom: 10px;\n    display: block;\n  }\n  quill-editor{\n    width: 100%;\n  }\n}\n.quill-wrapper{\n  .fl-left{\n    margin-bottom: 10px;\n    display: block;\n  }\n  quill-editor{\n    width: 100%;\n  }\n}\n.fileExplorer{\n  margin-top: 20px;\n  margin-bottom: 0px !important;\n}\n\n.clickable-text {\n  color: #007bff; /* Link color */\n  cursor: pointer; /* Pointer cursor on hover */\n  text-decoration: underline; /* Underline text */\n}\n\n.clickable-text:hover {\n  color: #0056b3; /* Darker shade on hover */\n}\n\n.doc-icon-btn {\n  cursor: pointer;\n  padding: 5px;\n  font-size: 20px;\n  color: #6b7280;\n  border-radius: 4px;\n  transition: color 0.2s ease, background 0.2s ease;\n\n  &:hover {\n    color: #111827;\n    background: rgba(0, 0, 0, 0.06);\n  }\n}\n\n:host-context(body.theme-dark) {\n  .doc-icon-btn {\n    color: #94a3b8 !important;\n\n    &:hover {\n      color: #e2e8f0 !important;\n      background: rgba(148, 163, 184, 0.12) !important;\n    }\n  }\n\n  .example-box.document-row {\n    .document,\n    .link {\n      color: #cbd5e1 !important;\n    }\n  }\n}\n\n.bundle-access-type-row {\n  margin-bottom: 12px;\n}\n\n.bundle-access-type-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.access-type-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #cbd5e1;\n  border-radius: 999px;\n  background: #fff;\n  color: #334155;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  mat-icon {\n    width: 18px;\n    height: 18px;\n    font-size: 18px;\n  }\n\n  &.selected {\n    border-color: #5ea1d8;\n    background: #eef6fc;\n    color: #1e4d72;\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n.access-type-check {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  margin-left: 2px;\n}\n\n::ng-deep .access-menu-current {\n  margin-left: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #1976d2;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
